// Tap the culprit: the bloods slip is the answer area. Every row is a 48 px button; the row a player taps is
// highlighted like a marker pen on paper, and at the reveal the culprit is circled and the room's split shown.
import { useMemo } from 'react';
import { Stem } from '@/components/Stem';
import { BloodsSlip, type SlipPick } from '@/clinical/BloodsSlip';
import type { FormatViewProps } from './types';
import { answerState, effectivePhase, sharePct } from './layout';
import { mapSpotRows } from './spotMap';
import { OptionList, useAnswerTap } from './parts';
import { Split, useWide } from './split';

export function SpotView(props: FormatViewProps) {
  const { question: q, myOptionId, reveal } = props;
  const phase = effectivePhase(props.phase, myOptionId, reveal);
  const { tap, live } = useAnswerTap({ ...props, phase });
  const bloods = q.graphic?.type === 'bloods' ? q.graphic : undefined;
  const map = useMemo(() => mapSpotRows(bloods?.rows ?? [], q.options), [bloods, q.options]);
  const pick: SlipPick = {
    rowOption: map.rowOption,
    stateOf: (id) => answerState(id, phase, myOptionId, reveal),
    disabled: !live,
    onPick: tap,
    pctOf: phase === 'revealed' && reveal ? (id) => sharePct(reveal, id) : undefined,
    mine: myOptionId,
  };
  // On a desktop the slip is the control, so it stays on the left; options with no row on the slip go on the right.
  const rest = map.unmatched.length > 0
    ? <OptionList options={map.unmatched} phase={phase} myOptionId={myOptionId} reveal={reveal} live={live} onTap={tap} layout="rows" />
    : undefined;
  const wide = useWide() && Boolean(rest);
  return (
    <div className="fx-format" data-format="spot" data-phase={phase} data-display="phones" data-layout={wide ? 'split' : undefined}>
      <Split wide={wide}
        left={<>
          <Stem text={q.stem} />
          {bloods && <BloodsSlip graphic={bloods} pick={pick} revealed={phase === 'revealed'} stem={q.stem} />}
        </>}
        right={rest} />
    </div>
  );
}
